/**
 * Removes citation / attachment markers from clinical impression markdown.
 * Matches Lexical import patterns in transformers.ts (footnote_ref, GFM-style footnotes).
 */
export function stripCitationMarkersFromMarkdown(markdown: string): string {
  let s = markdown;
  // [footnote_ref:1:docRef] — primary attachment/citation syntax
  s = s.replace(/\[footnote_ref:\d+:[^\]]*]/g, '');
  // [^id] inline footnote references
  s = s.replace(/\[\^[A-Za-z0-9_]+\](?!:)/g, '');
  // [^id]: footnote definition lines
  s = s.replace(/^\[\^[A-Za-z0-9_]+\]:[^\n]*\n?/gm, '');
  return s;
}
